import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { SwitchUserIcon } from "../../Icons";
import ToolTip from "../../Header/ToolTip";
import { SwitchUser } from "../../../redux/actions/auth";
import LoadingSpinner from "../../Common/LoadingSpinner";

const SwitchUserButton = ({ user }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSwitchUser = async () => {
    if (loading || !user?.key) return;

    setShowTooltip(false);
    setLoading(true);

    try {
      const data = {
        key: user.key,
        impersonator: user.impersonator,
        impersonated: user.impersonated,
      };

      await dispatch(SwitchUser(data));
      // Window redirects inside SwitchUser; loading spinner remains visible until unload
    } catch (error) {
      console.error("Error in switching user:", error);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="relative">
        <button
          type="button"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={handleSwitchUser}
          disabled={loading}
          aria-label="Switch User"
          className="active:bg-background-active bg-background-secondary group hover:bg-background-hover flex justify-center items-center rounded-full space-x-3 py-2 px-4 cursor-pointer transition-all duration-300 ease-in-out border-none outline-none disabled:opacity-50"
        >
          <SwitchUserIcon className="w-8 h-8 text-primary-600 group-hover:bg-background-active rounded-full" />

          <span className="max-[445px]:hidden max-[576px]:pl-2 text-primary-600 text-sm font-medium leading-tight tracking-tight pr-0.5 select-none">
            Switch
          </span>
          
          <ToolTip
            text="Switch User"
            showTooltip={showTooltip}
            className="top-12 min-w-max"
          />
        </button>
      </div>

      {loading && <LoadingSpinner />}
    </>
  );
};

export default SwitchUserButton;